/* eslint-disable camelcase */
import { useConfig } from "../../_util/use-config";
import { getGlobalConfig } from "../ConfigProvider";
import { zh_cn } from "./locale/zh_cn";
import { translationMap } from "./translationMap";
export function useTranslation() {
    var configLocale = useConfig().locale;
    var globalConfig = getGlobalConfig();
    return (translationMap[globalConfig === null || globalConfig === void 0 ? void 0 : globalConfig.locale] ||
        translationMap[configLocale] ||
        zh_cn);
}
/* eslint-enable camelcase */
//# sourceMappingURL=translation.js.map